function getEbayItemUrl(item = {}) {
  const candidates = [
    item.url,
    item.viewItemURL,
    item.view_item_url,
    item.itemUrl,
    item.item_url,
    item.link,
  ];

  for (const candidate of candidates) {
    if (typeof candidate !== 'string' || !candidate.trim()) {
      continue;
    }

    const value = candidate.trim();
    const absoluteValue = value.startsWith('//')
      ? `https:${value}`
      : /^www\./i.test(value)
        ? `https://${value}`
        : value.startsWith('/itm/')
          ? `https://www.ebay.com${value}`
          : value;

    try {
      const url = new URL(absoluteValue);
      if (
        (url.protocol === 'https:' || url.protocol === 'http:') &&
        (url.hostname === 'ebay.com' || url.hostname.endsWith('.ebay.com'))
      ) {
        url.protocol = 'https:';
        return url.href;
      }
    } catch {
      // Try the item ID or title fallback below.
    }
  }

  const itemId = [item.item_id, item.itemId, item.id, item.comp_id].find(
    (value) => /^\d{9,15}$/.test(String(value || ''))
  );
  if (itemId) {
    return `https://www.ebay.com/itm/${itemId}`;
  }

  const query = item.title || item.name || 'sports trading card';
  return `https://www.ebay.com/sch/i.html?_nkw=${encodeURIComponent(query)}`;
}

export { getEbayItemUrl };
